var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    {
      staticClass: "cmp cmp-product-thumb",
      attrs: { "data-testing": _vm.item.variation.id }
    },
    [
      _c(
        "div",
        { class: _vm.paddingClasses, style: _vm.paddingInlineStyles },
        [
          _c("div", { staticClass: "thumb-image" }, [
            _c(
              "div",
              { staticClass: "prop-1-1" },
              [
                _vm._t("item-image", [
                  _c("category-image-carousel", {
                    ref: "categoryImageCarousel",
                    attrs: {
                      "image-urls-data": _vm._f("itemImages")(
                        _vm.item.images,
                        _vm.imageUrlAccessor
                      ),
                      alt: _vm._f("itemName")(_vm.item),
                      title: _vm._f("itemName")(_vm.item),
                      "item-url": _vm._f("itemURL")(
                        _vm.item,
                        _vm.urlWithVariationId
                      ),
                      "enable-carousel":
                        _vm.$ceres.config.item.enableImageCarousel,
                      "disable-carousel-on-mobile": _vm.disableCarouselOnMobile
                    }
                  })
                ])
              ],
              2
            )
          ]),
          _vm._v(" "),
          _vm._t("item-details", [
            _c(
              "div",
              { staticClass: "thumb-content" },
              [
                _c(
                  "a",
                  {
                    staticClass: "thumb-title small",
                    class: {
                      "stretched-link":
                        _vm.$ceres.config.global.shippingCostsCategoryId == 0
                    },
                    attrs: {
                      href: _vm._f("itemURL")(_vm.item, _vm.urlWithVariationId)
                    }
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm._f("itemName")(_vm.item))
                    ),
                    _vm._l(_vm.item.groupedAttributes, function(attribute) {
                      return _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("translate")(
                              "Ceres::Template.itemGroupedAttribute",
                              attribute
                            )
                          )
                        )
                      ])
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "thumb-meta mt-2" },
                  [
                    _vm._t("before-prices"),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "prices justify-content-center" },
                      [
                        _vm.item.prices.rrp &&
                        _vm.item.prices.rrp.price.value > 0 &&
                        _vm.item.prices.rrp.price.value >
                          _vm.item.prices.default.unitPrice.value
                          ? _c("div", { staticClass: "price-view-port" }, [
                              _vm.item.prices.specialOffer
                                ? _c("del", { staticClass: "crossprice" }, [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm._f("itemCrossPrice")(
                                            _vm.item.prices.default.unitPrice
                                              .formatted,
                                            true
                                          )
                                        ) +
                                        "\n                            "
                                    )
                                  ])
                                : _c("del", { staticClass: "crossprice" }, [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm._f("itemCrossPrice")(
                                            _vm.item.prices.rrp.unitPrice
                                              .formatted
                                          )
                                        ) +
                                        "\n                            "
                                    )
                                  ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showme != undefined
                          ? [
                              _c(
                                "div",
                                { staticClass: "price" },
                                [
                                  _vm.item.item.itemType === "set"
                                    ? [
                                        _vm._v(
                                          "\n                             ab " +
                                            _vm._s(
                                              _vm.$translate(
                                                "Ceres::Template.itemSetPrice",
                                                {
                                                  price:
                                                    _vm.showme.price.formatted
                                                }
                                              )
                                            ) +
                                            "\n                          "
                                        )
                                      ]
                                    : !!_vm.item.item &&
                                      _vm.item.item.salableVariationCount > 1 &&
                                      _vm.$ceres.isCheapestSorting
                                    ? [
                                        _vm._v(
                                          "\n                            ab " +
                                            _vm._s(
                                              _vm.$translate(
                                                "Ceres::Template.categoryItemFromPrice",
                                                {
                                                  price:
                                                    _vm.showme.price.formatted
                                                }
                                              )
                                            ) +
                                            "\n                          "
                                        )
                                      ]
                                    : [
                                        _vm._v(
                                          "\n                            ab " +
                                            _vm._s(
                                              _vm._f("currency")(
                                                _vm.showme.price.value
                                              )
                                            ) +
                                            "\n                          "
                                        )
                                      ]
                                ],
                                2
                              )
                            ]
                          : [
                              _c(
                                "div",
                                { staticClass: "price" },
                                [
                                  _vm.item.item.itemType === "set"
                                    ? [
                                        _vm._v(
                                          "\n                             " +
                                            _vm._s(
                                              _vm.$translate(
                                                "Ceres::Template.itemSetPrice",
                                                { price: _vm.itemSetPrice }
                                              )
                                            ) +
                                            "\n                          "
                                        )
                                      ]
                                    : !!_vm.item.item &&
                                      _vm.item.item.salableVariationCount > 1 &&
                                      _vm.$ceres.isCheapestSorting
                                    ? [
                                        _vm._v(
                                          "\n                             " +
                                            _vm._s(
                                              _vm.$translate(
                                                "Ceres::Template.categoryItemFromPrice",
                                                { price: _vm.itemPrice }
                                              )
                                            ) +
                                            "\n                          "
                                        )
                                      ]
                                    : [
                                        _vm._v(
                                          "\n                             " +
                                            _vm._s(
                                              _vm._f("currency")(
                                                _vm.item.prices.default
                                                  .unitPrice.value
                                              )
                                            ) +
                                            "\n                          "
                                        )
                                      ]
                                ],
                                2
                              )
                            ]
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _vm.showme != undefined
                      ? [
                          _c("div", {
                            staticClass: "base-price text-muted",
                            domProps: {
                              innerHTML: _vm._s(_vm.showme.basePrice)
                            }
                          })
                        ]
                      : [
                          _c("div", {
                            staticClass: "base-price text-muted",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.item.prices.default.basePrice
                              )
                            }
                          })
                        ]
                  ],
                  2
                ),
                _vm._v(" "),
                _vm._t("after-prices")
              ],
              2
            )
          ])
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }